module.exports = __webpack_public_path__ + "img/kvalitetselement_fysisk_kjemiske.28435582.jpg";